const Hero = () => {
  return (
    <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-20">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-5xl font-bold mb-4">
          Welcome to My Portfolio
        </h1>
        <p className="text-xl mb-8 text-blue-100">
          Building amazing things with code
        </p>
        <div className="flex gap-4 justify-center">
          <a
            href="#projects"
            className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
          >
            View Projects
          </a>
          <a
            href="#contact"
            className="border-2 border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  )
}

export default Hero
